export default __webpack_public_path__ + "static/media/qrclient.ae634620.yaml";